/* eslint-disable functional/no-throw-statement */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/no-expression-statement */
/* eslint-disable functional/no-let */
/* eslint-disable functional/no-loop-statement */
/* eslint-disable no-await-in-loop */
import fetch from 'isomorphic-fetch';
import HttpError, { STATUS_CODE } from './HttpError';

const sleep = (milliseconds: number):
Promise<Function> => new Promise((resolve) => setTimeout(resolve, milliseconds));

export default async function asyncPost(token: string, url: string, body: object, getResult = true):
Promise<object | HttpError> {
  const newToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: newToken,
    },
    method: 'POST',
    body: JSON.stringify(body),
  };
  const response = await fetch(url, options);
  const statusLocation = response.headers.get('location');
  if (!statusLocation) {
    throw new HttpError(response.status as STATUS_CODE);
  }
  const retryTime = Number(response.headers.get('retry-after'));
  const retryOptions = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: newToken,
    },
    method: 'GET',
    redirect: getResult ? undefined : 'manual' as RequestRedirect,
  };
  let finalRes = { } as Response;
  while ((getResult && finalRes.status !== 200)
   || (!getResult && finalRes.type !== 'opaqueredirect')) {
    finalRes = await fetch(statusLocation, retryOptions);
    if (finalRes.status > 399) {
      throw new HttpError(finalRes.status as STATUS_CODE);
    }
    await sleep(retryTime * 1000);
  }
  return getResult ? finalRes.json() : null;
}
